$(function () {
    // Это для работы в кэше, чтобы каждый раз не показывать одни и те же товары, а рандомно выбирать
    const $otherProducts = $('.sidebar .show-random')

    const elNumber = $otherProducts.length;
    if (!elNumber) {
        return;
    }

    function randomInteger(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    }

    if (elNumber === 1) {
        $otherProducts.removeClass('d-none invisible');
        return;
    }

    const first = randomInteger(0, elNumber)
    let second = first

    while (second === first) {
        second = randomInteger(0, elNumber)
    }

    $otherProducts.addClass('d-none');
    $otherProducts.eq(first).removeClass('d-none');
    $otherProducts.eq(second).removeClass('d-none');
    $otherProducts.removeClass('invisible');
    $otherProducts.filter('.d-none').remove()
});
